<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div class="card-header bg-primary font-weight-bold text-white" style="display: flex; align-items: center;">
      Data Anggota
      <Button class="btn btn-md btn-dark px-4 py-2 ml-auto text-white" @click="$router.push('/keanggotaan/data-anggota/unverified')" >Kembali</Button>
    </div>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #214073 !important;"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Data Anggota</router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-sertifikasi/'+this.$route.params.id_user"
          style="background-color: #486ba7;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Data Sertifikasi</router-link>
      </li>

      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-rpl/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Data RPL</router-link>
      </li>

      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-pelatihan/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Data Pelatihan</router-link>
      </li>

      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-sanksi/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >
          Sanksi
        </router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>            
            <select class="form-control" name="pageSize" id="pageSize" @change="changePageSize">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="100">100</option>
              <option value="Semua Data">Semua Data</option>
            </select>
          </div>
        </div>        
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name="search" id="search" v-model.trim="search" class="form-control" placeholder="Cari Data ..."  />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>

            <template #nama_sertifikasi="{item}">
              <td class="py-2">{{ item.nama_sertifikasi ? item.nama_sertifikasi : '-' }}</td>
            </template>

            <template #status_pembayaran="{ item }">
              <td
                class="py-2 text-success font-weight-bold"
                v-if="item.status_pembayaran == 'settlement'"
              >
                Lunas
              </td>
              <td
                class="py-2 text-purple font-weight-bold"
                v-else-if="item.status_pembayaran == 'pending'"
              >
                Menunggu Pembayaran
              </td>
              <td
                class="py-2 text-secondary font-weight-bold"
                v-else-if="item.status_pembayaran == 'expired'"
              >
                Expired
              </td>
              <td
                class="py-2 text-secondary font-weight-bold"
                v-else-if="item.status_pembayaran == 'failure'"
              >
                Pembayaran Gagal
              </td>
              <td
                class="py-2 text-danger font-weight-bold"
                v-else-if="item.status_pembayaran == 0"
              >
                Belum Dibayar
              </td>
              <td
                class="py-2 text-danger font-weight-bold"
                v-else
              >
                Belum Lunas
              </td>
            </template>

            <template #status_pembatalan="{ item }">
                <td
                  class="py-2 text-success font-weight-bold"
                  v-if="item.status_pembatalan == 'Disetujui'"
                  
                >
                  Disetujui
                </td>
                <td
                  class="py-2 text-danger font-weight-bold"
                  v-else-if="item.status_pembatalan == 'Ditolak'"
                >
                  Ditolak
                </td>
                <td
                  class="py-2 text-warning font-weight-bold"
                  v-else-if="item.status_pembatalan == 'Pengajuan'"
                >
                  Pengajuan
                </td>
                <td class="py-2 text-secondary font-weight-bold" v-else>
                  Tidak Ada Pengajuan
                </td>
              </template>
              <template #aksi="{ item }">
                <td class="py-2 text-center d-flex align-items-center">
                <router-link :to="'/sertifikasi/data-peserta-sertifikasi/'+item.id_sertifikasi_peserta">
                  <CButton v-c-tooltip="'Detail Peserta'" color="success" class="btn-sm text-white mr-1" square>
                    <i class="fas fa-eye"></i>
                  </CButton>
                </router-link>
                </td>
              </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>   

      <!-- Modal Pembatalan User -->
      <ModalPengajuanPembatalanSertifikasi
        :modalDetailPembatalan="modalDetailPembatalan"
        :title="modalTitleDetailPembatalan"
        :formData="formDataPembatalan"
        @closeModalPembatalan="closeModalPembatalan($event)"
      />
      <!-- End Modal Pembatalan User -->   
    </CCardBody>
  </CCard>
</template>
<script>
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import RiwayatPesertaService from '@/services/keanggotaan/data-anggota/riwayat-peserta.service.js';
import ModalPengajuanPembatalanSertifikasi from "@/components/sertifikasi/datapeserta/ModalPengajuanPembatalanSertifikasi";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_sertifikasi",
    label: "Nama Sertifikasi",
    sorter: true,
    filter: false,
  },  
  {
    key: "label_periode",
    label: "Periode",
    sorter: true,
    filter: false,
  },  
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false,    
  },
  {
    key: "status_pembatalan",
    label: "Status Pembatalan",
    sorter: true,
    filter: false,
    _style: "text-align: center"
  },
  'aksi'
];

export default {
  name: 'data-sertifikasi-anggota',

  mixins: [AlertUtils, Pagination],

  components: {
    ModalPengajuanPembatalanSertifikasi
  },

  data() {
    return {      
      items: [],
      fields,      

      formDataPembatalan: {},
      modalDetailPembatalan: false,
      modalTitleDetailPembatalan: "Detail Pembatalan",
      
      // pagination
      pagination: {
        totalPages: 0,
      },
      currentPage: 0,
      pageSize: 10,
      indexed: 0,
      search: ''
    };
  },

  mounted() {  
    this.getData("0", this.pageSize, this.search);
  },

  methods: {
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      RiwayatPesertaService.getRiwayatSertifikasi(
        currentPage,
        pageSize,
        filter,
        this.$route.params.id_user
      )
        .then((response) => {
          loader.hide();      
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },    

    closeModalPembatalan(e) {
      if(e === false) {
        this.modalDetailPembatalan = false;
      }
    }
  },
};
</script>
